exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-buttons div {\n  margin-bottom: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/DocumentsModule/DocumentCreateDialogComponent/document-create.dialog.component.scss
// module id = ../../../../../src/DocumentsModule/DocumentCreateDialogComponent/document-create.dialog.component.scss
// module chunks = main